import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { fromEvent, Observable, tap } from 'rxjs';
import { WINDOW } from '@ng-web-apis/common';
import { ComponentStore } from '@ngrx/component-store';

interface PageVisibilityStore {
  pageVisible: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class PageVisibilityService extends ComponentStore<PageVisibilityStore> {
  setVisibility = this.effect((visibility$: Observable<any>) => {
    return visibility$.pipe(
      tap(() => {
        this.patchState({
          pageVisible: this.document.visibilityState === 'visible',
        });
      })
    );
  });

  setFocus = this.effect((focus$: Observable<Event>) => {
    return focus$.pipe(
      tap(() => {
        this.patchState({
          pageVisible: true,
        });
      })
    );
  });

  setBlur = this.effect((blur$: Observable<Event>) => {
    return blur$.pipe(
      tap(() => {
        this.patchState({
          pageVisible: false,
        });
      })
    );
  });

  readonly pageVisible$ = this.select((s) => s.pageVisible);

  //readonly pageVisible = this.get((s) => s.pageVisible);

  get pageVisible(): boolean {
    return this.get((s) => s.pageVisible);
  }

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(WINDOW) private window: Window
  ) {
    super({ pageVisible: true });
    this.setVisibility(fromEvent(this.document, 'visibilitychange'));
    this.setBlur(fromEvent(this.window, 'blur'));
    this.setFocus(fromEvent(this.window, 'focus'));
  }
}
